import { ErrorBoundary } from 'components/common/error-boundary';
import { CommonSliderInput } from 'components/common/form/slider';
import { useState } from 'react';

export const FeatureDemoSlider = () => {
  // Slider with input demo state
  const [sliderDemoValue, setSliderDemoValue] = useState<number>(0);

  return (
    <ErrorBoundary identifier="FeatureDemoSlider">
      <CommonSliderInput
        id="demo-slider-with-input"
        label="Roll"
        value={sliderDemoValue}
        onChange={setSliderDemoValue}
        min={-180}
        max={180}
        step={0.01}
        units="deg"
        decimals={2}
        withInput
      />
    </ErrorBoundary>
  );
};
